var _regeneratorRuntime = require("/var/lib/jenkins/workspace/HFM_MS_R6.10_Oct17-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/var/lib/jenkins/workspace/HFM_MS_R6.10_Oct17-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function node_modulesBabelRuntimeCorejs3HelpersClassCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function node_modulesBabelRuntimeCorejs3HelpersDefinePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "HttpTransport", function () {
      return HttpTransport_HttpTransport;
    }), __webpack_require__.d(__webpack_exports__, "HttpRequest", function () {
      return HttpRequest_HttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "HttpRequestBuilder", function () {
      return HttpRequestBuilder_HttpRequestBuilder;
    }), __webpack_require__.d(__webpack_exports__, "REQUEST_HANDLER_TYPE", function () {
      return REQUEST_HANDLER_TYPE;
    }), __webpack_require__.d(__webpack_exports__, "createJsonHttpRequest", function () {
      return createJsonHttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "createHttpRequest", function () {
      return createHttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "basicAuthOptions", function () {
      return basicAuthOptions;
    }), __webpack_require__.d(__webpack_exports__, "tokenAuthOptions", function () {
      return tokenAuthOptions;
    }), __webpack_require__.d(__webpack_exports__, "jsonOptions", function () {
      return jsonOptions;
    }), __webpack_require__.d(__webpack_exports__, "langLocaleOptions", function () {
      return langLocaleOptions;
    }), __webpack_require__.d(__webpack_exports__, "analyticsHandler", function () {
      return analyticsHandler;
    }), __webpack_require__.d(__webpack_exports__, "authTokenHandler", function () {
      return authTokenHandler;
    }), __webpack_require__.d(__webpack_exports__, "zipkinTraceHandler", function () {
      return zipkinTraceHandler;
    }), __webpack_require__.d(__webpack_exports__, "fastOptionsMerge", function () {
      return fastOptionsMerge;
    });

    var now_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/date/now"),
        now_default = __webpack_require__.n(now_),
        classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
        classCallCheck_default = __webpack_require__.n(classCallCheck),
        defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
        defineProperty_default = __webpack_require__.n(defineProperty),
        promise_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/promise"),
        promise_default = __webpack_require__.n(promise_);

    function fastOptionsMerge(defaults, overrides) {
      var headers = _objectSpread({}, null == defaults ? void 0 : defaults.headers, {}, null == overrides ? void 0 : overrides.headers);

      return _objectSpread({}, defaults, {}, overrides, {
        headers: headers
      });
    }

    function onResolvePromise(value) {
      return promise_default.a.resolve(value);
    }

    function onRejectPromise(value) {
      return promise_default.a.reject(value);
    }

    function defaultOnTrace() {}

    function defaultOnFetch(url, options) {
      var fetchCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetch;
      return fetchCall(url, options);
    }

    var HttpTransport_HttpTransport = function HttpTransport(handlers) {
      var _this = this;

      classCallCheck_default()(this, HttpTransport), defineProperty_default()(this, "fetch", function _callee(url, method, opts) {
        var options, start, fetchWithTrace, response;
        return _regeneratorRuntime.async(function _callee$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _objectSpread({}, opts, {
                  method: method
                }), start = now_default()(), fetchWithTrace = function fetchWithTrace() {
                  var fetchOptions, authOptions;
                  return _regeneratorRuntime.async(function fetchWithTrace$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _this.onTrace("request", {
                            url: url,
                            options: options
                          });

                          fetchOptions = options;

                          if (!_this.onAuth) {
                            _context4.next = 7;
                            break;
                          }

                          _context4.next = 5;
                          return _regeneratorRuntime.awrap(_this.onAuth());

                        case 5:
                          authOptions = _context4.sent;
                          fetchOptions = fastOptionsMerge(options, authOptions);

                        case 7:
                          return _context4.abrupt("return", fetch(url, fetchOptions));

                        case 8:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, null, null, null, Promise);
                };
                _context5.prev = 1;
                _context5.next = 4;
                return _regeneratorRuntime.awrap(_this.onFetch(url, options, fetchWithTrace));

              case 4:
                response = _context5.sent;
                return _context5.abrupt("return", response.ok ? (_this.onTrace("response", {
                  url: url,
                  options: options,
                  response: response,
                  duration: now_default()() - start
                }), _this.onResponse(response)) : (_this.onTrace("error", {
                  url: url,
                  options: options,
                  error: response,
                  duration: now_default()() - start
                }), _this.onErrorResponse(response)));

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](1);
                return _context5.abrupt("return", (_this.onTrace("exception", {
                  url: url,
                  options: options,
                  exception: _context5.t0,
                  duration: now_default()() - start
                }), _this.onException(_context5.t0)));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, null, null, [[1, 8]], Promise);
      });

      var _ref = handlers || {},
          onAuth = _ref.onAuth,
          onErrorResponse = _ref.onErrorResponse,
          onException = _ref.onException,
          onFetch = _ref.onFetch,
          onResponse = _ref.onResponse,
          onTrace = _ref.onTrace;

      this.onAuth = onAuth, this.onErrorResponse = onErrorResponse || onRejectPromise, this.onException = onException || onRejectPromise, this.onFetch = onFetch || defaultOnFetch, this.onResponse = onResponse || onResolvePromise, this.onTrace = onTrace || defaultOnTrace;
    };

    var keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
        keys_default = __webpack_require__.n(keys_),
        for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
        for_each_default = __webpack_require__.n(for_each_),
        url_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/url"),
        url_default = __webpack_require__.n(url_),
        stringify_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/json/stringify"),
        stringify_default = __webpack_require__.n(stringify_),
        includes_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes"),
        includes_default = __webpack_require__.n(includes_);

    var defaultEncoder = function defaultEncoder(data, options) {
      return (null == options ? void 0 : options.headers) && (headers = options.headers)["Content-Type"] && includes_default()(_context = headers["Content-Type"]).call(_context, "application/json") ? stringify_default()(data) : data;

      var headers, _context;
    };

    function defaultResponseHandler(response) {
      if (204 === response.status) return promise_default.a.resolve(null);
      var contentType = response.headers.get("Content-Type");
      return contentType && includes_default()(contentType).call(contentType, "application/json") ? response.json() : contentType && includes_default()(contentType).call(contentType, "application/octet-stream") ? response.blob() : response.text();
    }

    function defaultErrorResponseHandler(response) {
      var message, error, contentType;
      return _regeneratorRuntime.async(function defaultErrorResponseHandler$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              error = {
                status: response.status,
                statusText: response.statusText || "<none>"
              }, contentType = response.headers.get("Content-Type");
              _context6.t0 = contentType;

              if (!_context6.t0) {
                _context6.next = 14;
                break;
              }

              if (!includes_default()(contentType).call(contentType, "application/json")) {
                _context6.next = 9;
                break;
              }

              _context6.next = 6;
              return _regeneratorRuntime.awrap(response.json());

            case 6:
              _context6.t1 = _context6.sent;
              _context6.next = 13;
              break;

            case 9:
              _context6.next = 11;
              return _regeneratorRuntime.awrap(response.text());

            case 11:
              _context6.t2 = _context6.sent;
              _context6.t1 = {
                message: _context6.t2
              };

            case 13:
              message = _context6.t1;

            case 14:
              return _context6.abrupt("return", promise_default.a.reject(_objectSpread({}, error, {}, message)));

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, null, Promise);
    }

    function defaultExceptionHandler(err) {
      return promise_default.a.reject(err.message);
    }

    function buildUrl(url, baseUrl) {
      return baseUrl ? new url_default.a(url, baseUrl).toString() : url;
    }

    var HttpRequest_HttpRequest = function HttpRequest(baseUrl, defaultOptions, handlerOverrides) {
      var _this2 = this;

      classCallCheck_default()(this, HttpRequest), defineProperty_default()(this, "get", function (url, params, optionOverrides) {
        var requestOptions = fastOptionsMerge(_this2.defaultOptions, optionOverrides),
            requestUrl = "".concat(buildUrl(url, _this2.baseUrl)).concat(function (params) {
          var _context;

          if (!params) return "";
          var fakeUrl = new url_default.a("http://www.gw.com");
          return for_each_default()(_context = keys_default()(params)).call(_context, function (key) {
            return fakeUrl.searchParams.append(key, params[key]);
          }), fakeUrl.search;
        }(params));
        return _this2.transport.fetch(requestUrl, "GET", requestOptions);
      }), defineProperty_default()(this, "post", function (url, data, optionOverrides) {
        return _this2.request(url, "POST", data, optionOverrides);
      }), defineProperty_default()(this, "put", function (url, data, optionOverrides) {
        return _this2.request(url, "PUT", data, optionOverrides);
      }), defineProperty_default()(this, "patch", function (url, data, optionOverrides) {
        return _this2.request(url, "PATCH", data, optionOverrides);
      }), defineProperty_default()(this, "delete", function (url, data, optionOverrides) {
        return _this2.request(url, "DELETE", data, optionOverrides);
      }), defineProperty_default()(this, "request", function (url, method, data, optionOverrides) {
        var onEncode = _this2.handlers.onEncode,
            requestOptions = fastOptionsMerge(_this2.defaultOptions, optionOverrides);
        return requestOptions.body = onEncode && data ? onEncode(data, requestOptions) : data, _this2.transport.fetch(buildUrl(url, _this2.baseUrl), method, requestOptions);
      }), this.baseUrl = baseUrl, this.defaultOptions = defaultOptions, this.handlers = _objectSpread({
        onEncode: defaultEncoder,
        onErrorResponse: defaultErrorResponseHandler,
        onException: defaultExceptionHandler,
        onResponse: defaultResponseHandler
      }, handlerOverrides), this.transport = new HttpTransport_HttpTransport(this.handlers);
    };

    var reduce_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/reduce"),
        reduce_default = __webpack_require__.n(reduce_),
        every_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/every"),
        every_default = __webpack_require__.n(every_),
        values_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/values"),
        values_default = __webpack_require__.n(values_),
        logger_ = __webpack_require__("@jutro/logger");

    var REQUEST_HANDLER_TYPE = {
      AUTH: "onAuth",
      FETCH: "onFetch",
      ENCODE: "onEncode",
      ERROR: "onErrorResponse",
      EXCEPTION: "onException",
      RESPONSE: "onResponse",
      TRACE: "onTrace"
    },
        REQUEST_HANDLER_TYPE_VALUES = values_default()(REQUEST_HANDLER_TYPE);

    var HttpRequestBuilder_HttpRequestBuilder = function HttpRequestBuilder() {
      var _this3 = this;

      var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      classCallCheck_default()(this, HttpRequestBuilder), defineProperty_default()(this, "addOptions", function (options) {
        return _this3.options || (_this3.options = []), _this3.options.push(options), _this3;
      }), defineProperty_default()(this, "addHandler", function (event, callback) {
        var _context;

        var handler = event;
        event && callback && (handler = _defineProperty({}, event, callback));
        return every_default()(_context = keys_default()(handler)).call(_context, function (eventKey) {
          return !!includes_default()(REQUEST_HANDLER_TYPE_VALUES).call(REQUEST_HANDLER_TYPE_VALUES, eventKey) || (logger_.log.warning("Invalid event type \"".concat(eventKey, "\" supplied to \"HttpRequestBuilder.addHandler()\"")), !1);
        }) ? (_this3.handlers || (_this3.handlers = []), _this3.handlers.push(handler), _this3) : _this3;
      }), defineProperty_default()(this, "build", function () {
        var _context2, _context3;

        var options = _this3.options && reduce_default()(_context2 = _this3.options).call(_context2, function (list, values) {
          return fastOptionsMerge(list, values);
        }),
            handlers = _this3.handlers && reduce_default()(_context3 = _this3.handlers).call(_context3, function (list, values) {
          return _objectSpread({}, list, {}, values);
        });
        return new HttpRequest_HttpRequest(_this3.baseUrl, options, handlers);
      }), this.baseUrl = baseUrl;
    };

    var locale_ = __webpack_require__("@jutro/locale"),
        events_ = __webpack_require__("@jutro/events");

    var eventTopicMap = {
      request: events_.JUTRO_TOPICS.FETCH_REQUEST,
      response: events_.JUTRO_TOPICS.FETCH_RESPONSE,
      error: events_.JUTRO_TOPICS.FETCH_ERROR,
      exception: events_.JUTRO_TOPICS.FETCH_ERROR
    },
        analyticsHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.TRACE, function (event, payload) {
      Object(events_.publish)(eventTopicMap[event], payload);
    }),
        jsonOptions = {
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    };

    function langLocaleOptions(language, locale) {
      return {
        headers: {
          "gw-language": language,
          "gw-locale": locale
        }
      };
    }

    function createHttpRequest(baseUrl) {
      var build = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var request = new HttpRequestBuilder_HttpRequestBuilder(baseUrl).addOptions(langLocaleOptions(locale_.LocaleService.getCurrentLanguage(), locale_.LocaleService.getCurrentLocale())).addHandler(analyticsHandler);
      return build ? request.build() : request;
    }

    function createJsonHttpRequest(baseUrl) {
      var build = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var request = createHttpRequest(baseUrl, !1).addOptions(jsonOptions);
      return build ? request.build() : request;
    }

    function basicAuthOptions(userName, password) {
      return {
        headers: {
          Authorization: "Basic " + btoa("".concat(userName || "", ":").concat(password || ""))
        }
      };
    }

    function tokenAuthOptions(accessToken) {
      if (Object(logger_.warning)("tokenAuthOptions is deprecated, please use `authTokenHandler` that support token refresh/timeout"), accessToken) return {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
    }

    var auth_ = __webpack_require__("@jutro/auth");

    var authTokenHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.AUTH, function _callee2() {
      var accessToken;
      return _regeneratorRuntime.async(function _callee2$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _regeneratorRuntime.awrap(Object(auth_.getAccessToken)());

            case 2:
              accessToken = _context7.sent;
              return _context7.abrupt("return", {
                headers: {
                  Authorization: "Bearer " + accessToken,
                  "GW-Tenant": Object(auth_.decodeJWTTokenPayload)(accessToken).tenant_id
                }
              });

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, null, null, null, Promise);
    });

    var external_zipkin_ = __webpack_require__("zipkin"),
        external_zipkin_instrumentation_fetch_ = __webpack_require__("zipkin-instrumentation-fetch"),
        external_zipkin_instrumentation_fetch_default = __webpack_require__.n(external_zipkin_instrumentation_fetch_),
        external_zipkin_transport_http_ = __webpack_require__("zipkin-transport-http"),
        config_ = __webpack_require__("@jutro/config");

    var JSON_V2 = external_zipkin_.jsonEncoder.JSON_V2;

    function zipkinTraceHandler(remoteServiceName, localServiceName, zipkinUrl, debug) {
      var fetchCall = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : fetch;
      var recorder;
      var zipkinDebugConfigValue = Object(config_.getConfigValue)("zipkinDebug"),
          zipkinUrlConfigValue = Object(config_.getConfigValue)("zipkinUrl");
      recorder = debug || zipkinDebugConfigValue ? new external_zipkin_.ConsoleRecorder() : zipkinUrl || zipkinUrlConfigValue ? new external_zipkin_.BatchRecorder({
        logger: new external_zipkin_transport_http_.HttpLogger({
          endpoint: zipkinUrl || zipkinUrlConfigValue,
          jsonEncoder: JSON_V2,
          fetch: fetch
        })
      }) : {
        record: function record() {},
        toString: function toString() {
          return "nullTracer";
        }
      };
      var tracer = new external_zipkin_.Tracer({
        ctxImpl: new external_zipkin_.ExplicitContext(),
        recorder: recorder,
        localServiceName: localServiceName || Object(config_.getConfigValue)("zipkinLocalServiceName")
      });
      return _defineProperty({}, REQUEST_HANDLER_TYPE.FETCH, function (url, options) {
        var theFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetchCall;
        return external_zipkin_instrumentation_fetch_default()(theFetch, {
          tracer: tracer,
          remoteServiceName: remoteServiceName || Object(config_.getConfigValue)("zipkinRemoteServiceName")
        })(url, options);
      });
    }
  },
  "@babel/runtime-corejs3/core-js-stable/date/now": function babelRuntimeCorejs3CoreJsStableDateNow(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/date/now");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/every": function babelRuntimeCorejs3CoreJsStableInstanceEvery(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/every");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babelRuntimeCorejs3CoreJsStableInstanceIncludes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/reduce": function babelRuntimeCorejs3CoreJsStableInstanceReduce(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");
  },
  "@babel/runtime-corejs3/core-js-stable/json/stringify": function babelRuntimeCorejs3CoreJsStableJsonStringify(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/json/stringify");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babelRuntimeCorejs3CoreJsStableObjectKeys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/object/values": function babelRuntimeCorejs3CoreJsStableObjectValues(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/values");
  },
  "@babel/runtime-corejs3/core-js-stable/promise": function babelRuntimeCorejs3CoreJsStablePromise(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/promise");
  },
  "@babel/runtime-corejs3/core-js-stable/url": function babelRuntimeCorejs3CoreJsStableUrl(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/url");
  },
  "@jutro/auth": function jutroAuth(module, exports) {
    module.exports = require("@jutro/auth");
  },
  "@jutro/config": function jutroConfig(module, exports) {
    module.exports = require("@jutro/config");
  },
  "@jutro/events": function jutroEvents(module, exports) {
    module.exports = require("@jutro/events");
  },
  "@jutro/locale": function jutroLocale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "@jutro/logger": function jutroLogger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js-pure/features/object/define-property": function coreJsPureFeaturesObjectDefineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  zipkin: function zipkin(module, exports) {
    module.exports = require("zipkin");
  },
  "zipkin-instrumentation-fetch": function zipkinInstrumentationFetch(module, exports) {
    module.exports = require("zipkin-instrumentation-fetch");
  },
  "zipkin-transport-http": function zipkinTransportHttp(module, exports) {
    module.exports = require("zipkin-transport-http");
  }
});